var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatarInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 15 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#7A86A8",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M218.115 273.571c0-.382 0-.6.002-.656.01-.751-.047-.98-.357-1.205-.495-.36-1.618-.563-3.613-.563-1.994 0-3.117.202-3.613.563-.309.225-.366.454-.356 1.205.001.056.002.274.002.656 0 .237-.197.429-.44.429h-.001c-.244 0-.441-.192-.441-.429 0-.375-.001-.59-.002-.645-.014-1.01.098-1.458.71-1.902.693-.505 1.968-.734 4.141-.734 2.174 0 3.45.23 4.142.734.612.444.724.893.71 1.902l-.002.645c0 .237-.198.429-.441.429-.244 0-.441-.192-.441-.429zm-3.968-3.993c-1.868 0-3.382-1.472-3.382-3.289 0-1.816 1.514-3.289 3.382-3.289 1.869 0 3.383 1.473 3.383 3.29 0 1.816-1.514 3.288-3.383 3.288zm0-.857c1.381 0 2.5-1.089 2.5-2.432s-1.119-2.431-2.5-2.431c-1.38 0-2.5 1.088-2.5 2.431s1.12 2.432 2.5 2.432zm-6.398.111h-3.308c-.243 0-.441-.192-.441-.428 0-.237.198-.43.441-.43h3.308l-1.415-1.383c-.171-.168-.17-.44.002-.606.173-.167.453-.166.624.002l2.162 2.114c.171.168.171.438 0 .605l-2.162 2.114c-.171.168-.45.17-.624.002-.172-.167-.173-.438-.002-.606l1.415-1.384z",
    transform: "translate(-204 -263)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarInfo);
export default __webpack_public_path__ + "static/media/avatar-info.6742395cceef32a6ea5edbbfaa7b4101.svg";
export { ForwardRef as ReactComponent };